export function FreeFood(Profile, $q) {

  var _freeFoods;
  var _subcategories;

  var FreeFood = {
    getFreeFood: getFreeFood };


  return FreeFood;

  function getFreeFood() {
    if (_subcategories)
    return $q.resolve(_subcategories);else

    return Profile.getFreeFoods().then(function (res) {
      _subcategories = {};
      _freeFoods = res.data;
      _freeFoods.forEach(function (food) {
        if (_subcategories.hasOwnProperty(food.subcategory)) {
          _subcategories[food.subcategory].push(food);
        } else {
          _subcategories[food.subcategory] = [food];
        }
      });
      return _subcategories;
    });
  }
}